import {
  EventAttendeeStatus,
  GetApiV1EventsMyApiArg,
  Group,
  User,
} from '@wellesley/openapi'

export type EventResolvedAttendee = {
  user: User
  uri: string
  status: EventAttendeeStatus
}

export type EventUnresolvedAttendee = {
  uri: string
  status: EventAttendeeStatus
}

export enum EventScope {
  CURRENT_USER = 'CURRENT_USER',
  USER = 'USER',
  MY_GROUP = 'MY_GROUP',
  // PUBLIC_GROUP = 'PUBLIC_GROUP',
  DISCOVER = 'DISCOVER',
  NOTIFICATIONS = 'NOTIFICATIONS',
}

export type DefaultEventConfigs = {
  scope: null
  scopeProps: null
  queryArgs: null
}

export type DiscoverEventConfigs = {
  scope: EventScope.DISCOVER
  scopeProps: null
  queryArgs: {
    mode: 'following'
  }
}

export type NotificationsEventConfigs = {
  scope: EventScope.NOTIFICATIONS
  scopeProps: null
  queryArgs: {
    notRespondedOnly: true
  }
}

export type CurrentUserEventConfigs = {
  scope: EventScope.CURRENT_USER
  scopeProps: {
    // Ex. 'username'
    username: string
  }
  queryArgs: null | {
    organizedOnly: boolean
  }
}

export type UserEventConfigs = {
  scope: EventScope.USER
  scopeProps: {
    // Ex. 'username' | 'username@domain'
    username: string
  }
  queryArgs: {
    // Ex. 'username' | 'username@domain'
    username: string
  }
}

export type MyGroupEventConfigs = {
  scope: EventScope.MY_GROUP
  scopeProps: {
    group: Group
  }
  queryArgs: { groupId: string }
}

export type EventConfigs =
  | DefaultEventConfigs
  | DiscoverEventConfigs
  | NotificationsEventConfigs
  | CurrentUserEventConfigs
  | UserEventConfigs
  | MyGroupEventConfigs

export type MyEventsFilters = Pick<
  GetApiV1EventsMyApiArg,
  'notRespondedOnly' | 'past' | 'organizedOnly'
>

export type MyEventsFiltersKeys = keyof MyEventsFilters
